import React from 'react'

import { AksiNyataSessionState, AppealState } from 'types/microlearning'

enum CardButtonVariant {
  White = 'white',
  Black = 'black',
}
interface CardDataValues {
  iconBackground: string
  badgeText: string
  cardElement: () => JSX.Element
  buttonText: string
  buttonVariant: CardButtonVariant
}

export const CARD_DATA_CERTIFICATE_NOT_AVAILABLE: CardDataValues = {
  iconBackground: 'bg-icon-disabled',
  badgeText: 'Sertifikat dalam proses',
  cardElement: () => (
    <>Begitu selesai diproses, sertifikat Anda akan muncul di sini</>
  ),
  buttonText: '',
  buttonVariant: CardButtonVariant.White,
}

export const CARD_DATA_NO_AKSI_NYATA: CardDataValues = {
  iconBackground: 'bg-icon-disabled',
  badgeText: 'Belum Tersedia',
  cardElement: () => (
    <>
      Kumpulkan lembar Aksi Nyata Anda agar dapat divalidasi dan berkesempatan
      memperoleh sertifikat
    </>
  ),
  buttonText: '',
  buttonVariant: CardButtonVariant.White,
}

export const CARD_DATA_CERTIFICATE_DONE: CardDataValues = {
  iconBackground: 'bg-icon-informational',
  badgeText: 'Sertifikat Tersedia',
  cardElement: () => <>Sertifikat Anda sudah dapat diunduh</>,
  buttonText: 'Lihat sertifikat',
  buttonVariant: CardButtonVariant.Black,
}

export const CARD_DATA_REVISION_DECLINED: CardDataValues = {
  iconBackground: 'bg-icon-disabled',
  badgeText: 'Hasil banding: Perbaiki Aksi Nyata',
  cardElement: () => (
    <>
      Setelah divalidasi ulang, Aksi Nyata Anda masih perlu diperbaiki. Silakan
      perbaiki sesuai saran untuk memperoleh sertifikat.
    </>
  ),
  buttonText: 'Baca saran perbaikan',
  buttonVariant: CardButtonVariant.White,
}

export const CARD_DATA_REVISION_NEEDED: CardDataValues = {
  iconBackground: 'bg-icon-disabled',
  badgeText: 'Perbaiki Aksi Nyata',
  cardElement: () => (
    <>
      Silakan perbaiki Aksi Nyata sesuai saran perbaikan untuk memperoleh
      sertifikat
    </>
  ),
  buttonText: 'Baca saran perbaikan',
  buttonVariant: CardButtonVariant.White,
}

export const CARD_DATA_WAITING_VALIDATION: CardDataValues = {
  iconBackground: 'bg-icon-disabled',
  badgeText: 'Menunggu Hasil Validasi',
  cardElement: () => (
    <>
      Proses validasi membutuhkan waktu lebih lama karena Aksi Nyata yang masuk
      cukup banyak. Mohon kesabaran Anda.
    </>
  ),
  buttonText: 'Pahami proses validasi',
  buttonVariant: CardButtonVariant.White,
}

export const CARD_DATA_WAITING_APPEAL: CardDataValues = {
  iconBackground: 'bg-icon-disabled',
  badgeText: 'Menunggu Hasil Banding',
  cardElement: () => (
    <>
      Aksi Nyata Anda sedang divalidasi ulang. Cek halaman ini secara berkala
      untuk melihat hasilnya.
    </>
  ),
  buttonText: 'Pahami proses validasi',
  buttonVariant: CardButtonVariant.White,
}

export const getCardDataValues = (
  cardState: AksiNyataSessionState,
  appealState: AppealState,
  isCertifiable: boolean
): CardDataValues => {
  if (cardState === AksiNyataSessionState.Validated && !isCertifiable)
    return CARD_DATA_CERTIFICATE_NOT_AVAILABLE

  if (cardState === AksiNyataSessionState.Validated)
    return CARD_DATA_CERTIFICATE_DONE

  if (
    cardState === AksiNyataSessionState.NeedRevision &&
    appealState === AppealState.Declined
  )
    return CARD_DATA_REVISION_DECLINED

  if (cardState === AksiNyataSessionState.NeedRevision)
    return CARD_DATA_REVISION_NEEDED

  if (cardState === AksiNyataSessionState.Completed)
    return CARD_DATA_WAITING_VALIDATION

  if (cardState === AksiNyataSessionState.Appeal)
    return CARD_DATA_WAITING_APPEAL

  return CARD_DATA_NO_AKSI_NYATA
}
